import React, { useState } from 'react'
import Modal from 'react-responsive-modal'
import styles from './MediaPreviewModal.module.css'

const MEDIA_TYPES = {
  image: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
  video: ['mp4', 'avi', 'mov'],
  audio: ['mp3', 'wav', 'ogg']
}

const getMediaType = (fileName) => {
  const ext = fileName?.split('.').pop()?.toLowerCase()
  if (MEDIA_TYPES.image.includes(ext)) return 'image'
  if (MEDIA_TYPES.video.includes(ext)) return 'video'
  if (MEDIA_TYPES.audio.includes(ext)) return 'audio'
  return null
}

export const isPreviewSupported = (fileName) => {
  return getMediaType(fileName) !== null
}

export default function MediaPreviewModal({ file, fileUrl, open, onClose }) {
  const [error, setError] = useState(null)

  if (!open || !file || !fileUrl) {
    return null
  }

  const mediaType = getMediaType(file.mr_name)

  const handleMediaError = (e) => {
    console.error('Media error:', e)
    setError('Не удалось загрузить файл')
  }

  const handleClose = () => {
    setError(null)
    onClose()
  }

  const renderContent = () => {
    if (error) {
      return <p className={styles.error}>{error}</p>
    }

    switch (mediaType) {
      case 'image':
        return (
          <div className={styles.imageContainer}>
            <img
              src={fileUrl}
              alt={file.mr_name}
              className={styles.image}
              onError={handleMediaError}
            />
          </div>
        )

      case 'video':
        return (
          <div className={styles.videoContainer}>
            <video
              key={fileUrl}
              controls
              className={styles.videoPlayer}
              onError={handleMediaError}
            >
              <source src={fileUrl} type="video/mp4" />
              Ваш браузер не поддерживает воспроизведение видео.
            </video>
          </div>
        )

      case 'audio':
        return (
          <div className={styles.audioContainer}>
            <div className={styles.audioIcon}>🎵</div>
            <p className={styles.audioTitle}>{file.mr_name}</p>
            <audio
              key={fileUrl}
              controls
              className={styles.audioPlayer}
              onError={handleMediaError}
            >
              <source src={fileUrl} />
              Ваш браузер не поддерживает воспроизведение аудио.
            </audio>
          </div>
        )

      default:
        return <p className={styles.error}>Предпросмотр недоступен для данного типа файла</p>
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      center
      classNames={{
        modal: mediaType === 'image' ? styles.imageModal : styles.modal
      }}
    >
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h3 className={styles.title}>{file.mr_name}</h3>
        </div>
        {renderContent()}
      </div>
    </Modal>
  )
}
